import { withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { defaultDataTypes } from '../../../components/Common/Utils/defaultDataTypes.js';
import { loadData, loadMore } from '../../feed/feedUtils';
import { loadMoreQuery, updateSpecificItemInState } from '../../search/searchUtils';
import LibraryPlaceholder from '../../../components/Placeholders/LibraryPlaceholder.js';
import TrendingTopics from './TrendingTopics/TrendingTopics'
import TrendingHashtags from './TrendingHashtags/TrendingHashtags'
import MostTrendingItems from './MostTrendingItems/MostTrendingItems.js';
import KanbanGroups from './KanbanGroups/KanbanGroups.js';
import AllDataTypes from './AllDataTypes/AllDataTypes.js';
import DataGroups from './DataGroups/DataGroups.js';
import KnowledgeGroups from './KnowledgeGroups/KnowledgeGroups.js';
import People from './People/People.js';
import CollectionsCards from './CollectionsCards/CollectionsCards.js';


const styles = theme => ({
    container: {
        width: '100vw',
        margin: '0px auto',
        backgroundColor: '#f5f5f5'
    },
})

const filterKanbanCollections = (allCollections = []) => allCollections.filter(collection => collection.defaultView === 'kanban')
const filterTableCollections = (allCollections = []) => allCollections.filter(collection => collection.defaultView === 'table')
const filterKnowledgeCollections = (allCollections = []) => allCollections.filter(collection => collection.defaultView === "knowledge" || collection.defaultView === "feed")
const sortKanbanCollectionsByUsers = (allCollections = []) => allCollections.sort((a, b) => {
    if(a.collectionGroup && a.collectionGroup.groupUsers && b.collectionGroup && b.collectionGroup.groupUsers) {
        return b.collectionGroup.groupUsers.length - a.collectionGroup.groupUsers.length
    }
    return 1
})

class DiscoveryLibrary extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            dataReloadInidicator: 0,
            feedPage: 0,
            results: [],
            isLoading: true,
            isLoadingMore: false,
            hasMore: true,
            hadEmptyResult: false
        }

        // Bind the utils
        this.loadData = loadData.bind(this);
        this.loadMore = loadMore.bind(this);
        this.updateSpecificItemInState = updateSpecificItemInState.bind(this);
        this.loadMoreQuery = loadMoreQuery.bind(this)
        this.defaultDataTypes = defaultDataTypes();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.oldUiData.needsUpdate) {
            this.loadData(nextProps.oldUiData.dataUpdate);
        } else if (nextProps.oldUiData.specificItemUpdate) {
            this.updateSpecificItemInState(nextProps.oldUiData.itemId)
        }
    }

    componentDidMount() {
        this.loadData(this.state.dataReloadInidicator)
    }

    render() {
        const { classes, allCollections} = this.props;
        const { results, isLoading } = this.state;

        if (!isLoading && results && results.length < 10) {
            return <LibraryPlaceholder />
        }
        const kanbanCollections = sortKanbanCollectionsByUsers(filterKanbanCollections(allCollections))
        const dataCollections = sortKanbanCollectionsByUsers(filterTableCollections(allCollections))
        const knowledgeCollections = sortKanbanCollectionsByUsers(filterKnowledgeCollections(allCollections))
        return (
            <div data-intrcm-id="discoveryLibrary_322laz66" className={classes.container} >
                <CollectionsCards allCollections={allCollections}/>
                <TrendingTopics />
                <People />
                <KanbanGroups kanbanCollections={kanbanCollections} />   
                <MostTrendingItems />
                <TrendingHashtags />
                <AllDataTypes />
                <DataGroups dataCollections={dataCollections} />
                <KnowledgeGroups knowledgeCollections={knowledgeCollections} />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    users: (state.globalData.users),
    userData: state.userData,
    router: state.router,
    ...state.services,
    viewOptions: state.viewOptions,
    wrapper: state.wrapper,
    classifications: state.globalData.classifications,
    knowledgelevels: state.globalData?.knowledgelevels ?? [],
    globalData: state.globalData,
    oldUiData: state.oldUiData,
    inputMappings: state.globalData.inputMappings,
    searchQuery: state.search,
})

const mapDispatchToProps = dispatch => ({
    dispatch,
})

export default compose(withStyles(styles), withTranslation('library'), connect(mapStateToProps, mapDispatchToProps))(DiscoveryLibrary);

